const PropertyFilters = {
  async init() {
    try {
      const filters = await PropertyAPI.getFilters();

      this.populateSelect(
        "filter-city",
        filters.normalized_cities || filters.cities
      );

      this.populateSelect(
        "filter-zip",
        filters.zips
      );

      this.populateSelect(
        "filter-status",
        filters.statuses
      );

      this.populateSelect(
        "filter-beds",
        filters.beds
      );

      this.populateSelect(
        "filter-baths",
        filters.baths
      );

      this.populateSelect(
        "filter-property-type",
        filters.property_categories ||
          filters.property_types
      );
    } catch (error) {
      console.error(
        "Unable to load property filters:",
        error
      );
    }
  },

  populateSelect(elementId, values) {
    const select = document.getElementById(elementId);

    if (!select || !Array.isArray(values)) {
      return;
    }

    /*
     * Preserve the first placeholder option while
     * preventing duplicated options after reloading.
     */
    while (select.options.length > 1) {
      select.remove(1);
    }

    const labels = {
      "Accepting Proxy": "Active Auctions",
      Sold: "Sold",
      Canceled: "Canceled"
    };

    const excludedValues = new Set([
      "-1",
      "NA",
      "Pre ForeClosure"
    ]);

    values.forEach((item) => {
      const isStructuredOption =
        item !== null &&
        typeof item === "object" &&
        !Array.isArray(item);

      const rawValue = isStructuredOption
        ? item.value
        : item;

      const rawLabel = isStructuredOption
        ? item.label
        : item;

      const value = String(rawValue ?? "").trim();
      const label = String(rawLabel ?? "").trim();

      if (
        !value ||
        excludedValues.has(value)
      ) {
        return;
      }

      const option = document.createElement("option");

      option.value = value;
      option.textContent =
        labels[value] || label || value;

      if (
        isStructuredOption &&
        Number.isFinite(Number(item.count))
      ) {
        option.dataset.count =
          String(item.count);
      }

      select.appendChild(option);
    });
  },

  getValues() {
    return {
      search:
        document
          .getElementById("filter-search")
          ?.value.trim() || "",

      city:
        document.getElementById("filter-city")
          ?.value || "",

      zip:
        document.getElementById("filter-zip")
          ?.value || "",

      status:
        document.getElementById("filter-status")
          ?.value || "",

      beds:
        document.getElementById("filter-beds")
          ?.value || "",

      baths:
        document.getElementById("filter-baths")
          ?.value || "",

      property_type:
        document.getElementById(
          "filter-property-type"
        )?.value || "",

      sort:
        document.getElementById(
          "sort-properties"
        )?.value || "sale_date_asc"
    };
  },

  clear() {
    const filterIds = [
      "filter-search",
      "filter-city",
      "filter-zip",
      "filter-status",
      "filter-beds",
      "filter-baths",
      "filter-property-type"
    ];

    filterIds.forEach((elementId) => {
      const element =
        document.getElementById(elementId);

      if (element) {
        element.value = "";
      }
    });

    const sortSelect =
      document.getElementById("sort-properties");

    if (sortSelect) {
      sortSelect.value = "sale_date_asc";
    }
  }
};